<div class="panel__content no-padding fleet-overview-table" >
    <div *ngIf="equipmentDataLoading || _loading != 0" [class.loading-initial]="equipmentDataLoading" [class.loading-next-page]="_loading != 0">
      <mat-spinner></mat-spinner>
    </div>
    
    <mat-table *ngIf="!equipmentDataLoading && _loading == 0 && enableTab" class="table-material table-material--striped table-material--hover table-material--full-width" #table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)" [@fadeInOut] [matSortActive]="_currentSort.active" matSortDisableClear [matSortDirection]="_currentSort.direction">
      <ng-container matColumnDef="modelImage" *ngIf="EnableDDashboardPreference.showModelImg">
        <mat-header-cell class="eval-header" *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><img class="model-image" src="/Api/Application/getModelThumbnail/?modelId={{row.modelId}}" /></mat-cell>
      </ng-container>
      <ng-container matColumnDef="EvalL" *ngIf="EnableDDashboardPreference.showEvalLR">
        <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef>{{ Translate('Eval (L)')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><div [ngClass]="getEvalClass(row, 0)">{{row.WornL!=-1? row.WornL + '%':'-' }}</div></mat-cell>
      </ng-container>
      <ng-container matColumnDef="EvalR" *ngIf="EnableDDashboardPreference.showEvalLR">
        <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef>{{ Translate('Eval (R)')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="mat-cell table__eval-cell"><div [ngClass]="getEvalClass(row, 1)">{{row.WornR!=-1 ? row.WornR + '%':'-' }}</div></mat-cell>
      </ng-container>

      <ng-container matColumnDef="therm" *ngIf="ThermEnabled && EnableDDashboardPreference.showTherm">
        <mat-header-cell *matHeaderCellDef style="text-align: center">{{ Translate('Therm L/R')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <diV style="display: flex; flex-direction: row; justify-content: space-evenly;">
            <div matTooltip="{{row.therm_L}}" [ngClass]="getThermoEvalClass(row,0)"></div>
            <div matTooltip="{{row.therm_R}}" [ngClass]="getThermoEvalClass(row,1)"></div>
          </diV>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customer" *ngIf="EnableDDashboardPreference.showCustomer">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Customer')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.customerName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="site" *ngIf="EnableDDashboardPreference.showJobsite">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Site')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" matTooltip="{{row.jobsiteName}}">  <div class="SerialAndUnitText">{{row.jobsiteName}}</div> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="inspector" *ngIf="EnableDDashboardPreference.showInspector">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Inspector')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" matTooltip="{{row.inspector}}">  <div class="InspectorName">{{row.inspector}}</div> </mat-cell>
      </ng-container>
      <ng-container matColumnDef="serial" *ngIf="EnableDDashboardPreference.showSerial">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Serial No.')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" matTooltip="{{row.serial}}"><div class="SerialAndUnitText">{{row.serial}}</div> </mat-cell>
      </ng-container>
      <ng-container matColumnDef="unit" *ngIf="EnableDDashboardPreference.showUnit">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Unit No.')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" matTooltip="{{row.unit}}"> <div class="SerialAndUnitText">  {{row.unit}}</div> </mat-cell>
      </ng-container>
      <ng-container matColumnDef="addiunit" *ngIf="EnableDDashboardPreference.showAdditonal">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Additional Unit No.')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" matTooltip="{{row.addiunit}}"> <div class="SerialAndUnitText">  {{row.addiunit}}</div> </mat-cell>
      </ng-container>
      <ng-container matColumnDef="make" *ngIf="EnableDDashboardPreference.showMake">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Make')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.make}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="model" *ngIf="EnableDDashboardPreference.showModel">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Model')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.model}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="family" *ngIf="EnableDDashboardPreference.showFamily">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Family')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.family}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="smu" *ngIf="EnableDDashboardPreference.showSMU">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('SMU/Hourmeter')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.smu}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Distance">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Distance')}} ({{userUOD}})  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{convertDistanceKmToMi(row.Distance)}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ltd" *ngIf="EnableDDashboardPreference.showLTD">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('LTD')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.ltd}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pmu" *ngIf="EnableDDashboardPreference.showPropel">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Propel %')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.pmu!=mull? row.pmupercentage.toFixed(1) : ' - '}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="AvgUsage" *ngIf="EnableDDashboardPreference.showAvgUsage">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Avg Usage')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.AvgUsage!=-99999? row.AvgUsage.toFixed(1) : ' N/A'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="residual" *ngIf="EnableDDashboardPreference.showResidual">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Residual Hrs')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.residual}} </mat-cell>
      </ng-container>


      <ng-container matColumnDef="replacementDate" *ngIf="EnableDDashboardPreference.showReplacementDate">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Replacement Date')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center">
          <div *ngIf="row.replacementDate != '0001-01-01T00:00:00' && row.replacementDate != '1900-01-01T00:00:00'">{{ row.replacementDate | date : 'dd MMM yyyy'}}</div>
          <div *ngIf="row.replacementDate == '0001-01-01T00:00:00' || row.replacementDate == '1900-01-01T00:00:00'">No Calc.</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastInspectionSmu">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Last Inspect SMU')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"> {{row.lastInspectionSmu}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastInspectionDate" *ngIf="EnableDDashboardPreference.showLastInspDate">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Last Inspect Date')}} </mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center">
          <div *ngIf="row.lastInspectionDateAsDate != '0001-01-01T00:00:00' && row.lastInspectionDateAsDate != '1900-01-01T00:00:00'">{{ row.lastInspectionDateAsDate | date : 'dd MMM yyyy'}}</div>
          <div *ngIf="row.lastInspectionDateAsDate == '0001-01-01T00:00:00' || row.lastInspectionDateAsDate == '1900-01-01T00:00:00'">&nbsp;</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="nextInspection" *ngIf="EnableDDashboardPreference.showNextInsp">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Next Inspect Date/SMU')}}</mat-header-cell>
        <mat-cell class="text-center" *matCellDef="let row">
          <span *ngIf="row.NextInspectionDate == '1900-01-01T00:00:00'">-</span>
          <span *ngIf="row.NextInspectionDate != '1900-01-01T00:00:00'" class="component-span top {{getNextInspectionCSSClass(row.NextInspectionDate)}}">{{(row.NextInspectionDate | date : 'dd MMM yyyy')}}/{{row.NextInspectionSMU}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Status" *ngIf="EnableDDashboardPreference.showStatus">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Status')}}  </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.equip_status}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="summaryNotes" *ngIf="EnableDDashboardPreference.showSummaryNotes">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Summary Notes')}}  </mat-header-cell>
        <mat-cell class="ignore-click text-center" *matCellDef="let row">
          <button class="ignore-click"
                  mat-icon-button
                  [matTooltip]="'Equipment Summary Notes' | translate | async"
                  (click)="openSummaryNotes(row)"
                  style="width: 28px; height: 28px;">
            <span *ngIf="row.SummaryNotesExists" style="cursor: pointer;" class="ignore-click">
              <i class="material-icons upload-container__icon  ignore-click" style="color: #ed5565;">
                summarize
              </i>
            </span>
            <span *ngIf="!row.SummaryNotesExists" style="cursor: pointer;" class="ignore-click">
              <i class="material-icons observation-image__icon  ignore-click">
                summarize
              </i>
            </span>
          </button>
        </mat-cell>
      </ng-container>
      <!--
  <ng-container matColumnDef="openInNewTab">
      <mat-header-cell class="hover-new-tab__header ignore-click" *matHeaderCellDef></mat-header-cell>
      <mat-cell class="hover-new-tab__cell ignore-click overflow-hidden" *matCellDef="let row">
          <div class="expand-on-hover__element">
              <button mat-icon-button (click)="openEquipmentNewTab($event, row.Id)" class="ignore-click new-tab-button" matTooltip="Open in new tab">
                  <mat-icon aria-label="Open in new tab" class="ignore-click">open_in_new</mat-icon>
              </button>
          </div>
      </mat-cell>
  </ng-container>-->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="hand-pointer expand-on-hover" (click)="rowClicked($event, row.Id)"></mat-row>
    </mat-table>
    <mat-paginator [hidden]="!(!equipmentDataLoading && _loading == 0 && enableTab)" #paginator
                   [pageSize]="loadSize"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   (page)="pageChanged($event)">
    </mat-paginator>
</div>
